// extracted by mini-css-extract-plugin
export default {"section-packs-prices__header":"section-packs-prices__header--3GFbB","section-packs-prices__grid":"section-packs-prices__grid--2Im32","section-packs-prices__grid--with-rows":"section-packs-prices__grid--with-rows--NDZMP","section-packs-prices__grid__content":"section-packs-prices__grid__content--2B2OT","section-packs-prices__alert":"section-packs-prices__alert--13gdV","section-packs-prices__footer":"section-packs-prices__footer--1XZp5"};
    if(module.hot) {
      // 1747648180726
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  